// extracted by mini-css-extract-plugin
export default {"navList":"NavMenu_navList__BRj3R","link":"NavMenu_link__DXUAg","mobileMenuWrap":"NavMenu_mobileMenuWrap__aXRSf","toggle":"NavMenu_toggle__Lv8Mf"};